import { set } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import {
  paginationState,
  resetPaginationState
} from '../../../../helpers/pagination';
import {
  createFetchManyHandler,
  createSaveHandler,
  createUpdateHandler,
  createDeleteHandler
} from '../../../../helpers/reducerRoutineCrudHandler';
import {
  fetchOutreaches,
  createOutreach,
  updateOutreach,
  deleteOutreach
} from '../../sagas/routines';
import {
  clearOutreaches,
  outreachesOnChangePage,
  outreachesOnChangeOrder
} from '../../actions/outreach';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  fetchingError: null,
  saving: false,
  saved: false,
  savingError: null,
  deleting: false,
  deleted: false,
  deletingError: null,
  pagination: paginationState(),
  order: 'id:desc'
};

const clearOutreachesHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    all: {},
    fetched: false,
    pagination: resetPaginationState(state.pagination)
  })
});

const onChangePageHandler = action => ({
  [action.toString()]: (state, { payload: tag }) =>
    set('pagination.currentPage', tag, state)
});

const onChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

export default createReducer(initialState, {
  ...createFetchManyHandler(fetchOutreaches),
  ...createSaveHandler(createOutreach),
  ...createUpdateHandler(updateOutreach),
  ...createDeleteHandler(deleteOutreach),
  ...clearOutreachesHandler(clearOutreaches),
  ...onChangePageHandler(outreachesOnChangePage),
  ...onChangeOrderHandler(outreachesOnChangeOrder)
});
